<!-- Public route: /knowledge-exam — no auth required (see router.js publicRoutes). -->
<template>
    <div class="wisdom-exam-page">
        <div class="hero-banner">
            <div class="hero-shape hero-shape-1"></div>
            <div class="hero-shape hero-shape-2"></div>
            <div class="hero-logos">
                <div class="hero-logo-chip">
                    <img src="https://guideportal.wisdomislam.org/uploads/image/1785763283.png" alt="E-Madrasa Junior">
                </div>
                <div class="hero-logo-chip">
                    <img src="https://guideportal.wisdomislam.org/uploads/image/1785763213.png" alt="E-Madrasa Senior">
                </div>
            </div>
            <h1 class="hero-title">Wisdom Students Knowledge Exam</h1>
            <p class="subtitle mal-text">വിസ്ഡം സ്റ്റുഡന്റ്സ് നോളജ് എക്സാം</p>
            <span class="status-badge mal-text">ഇപ്പോൾ രജിസ്റ്റർ ചെയ്യുക</span>
        </div>

        <div class="page-wrapper">
            <div class="floating-card">
                <div class="alert-box" :class="alertType === 'success' ? 'alert-success' : 'alert-error'" v-if="alertMessage">
                    {{ alertMessage }}
                </div>

                <!-- STEP: START -->
                <div class="step-container" :class="{ active: currentStep === 'start' }">
                    <button type="button" class="btn-main mal-text" @click="goToRegister">
                        പുതിയ രജിസ്ട്രേഷൻ (New Registration)
                    </button>
                    <button type="button" class="btn-outline mal-text" @click="goToLookup">
                        എന്റെ രജിസ്ട്രേഷൻ കാണുക (View My Registration)
                    </button>
                </div>

                <!-- STEP: REGISTER -->
                <div class="step-container" :class="{ active: currentStep === 'register' }">
                    <h2 class="section-title mal-text">രജിസ്ട്രേഷൻ ഫോം</h2>
                    <form @submit.prevent="submitRegistration">
                        <div class="form-group">
                            <label class="form-label mal-text">പേര് (Name) <span class="req">*</span></label>
                            <input type="text" v-model="formData.name" class="form-input" placeholder="Full name" required>
                        </div>
                        <div class="form-group">
                            <label class="form-label mal-text">രക്ഷിതാവിന്റെ പേര് (Parent Name) <span class="req">*</span></label>
                            <input type="text" v-model="formData.parent_name" class="form-input" placeholder="Parent's name" required>
                        </div>
                        <div class="form-group" v-if="isAddingFamilyMember">
                            <label class="form-label mal-text">പ്രധാന മൊബൈൽ നമ്പർ (Mobile)</label>
                            <div class="locked-mobile-display">
                                <span>{{ formData.mobile }}</span>
                                <button type="button" class="link-btn" style="padding:0;" @click="isAddingFamilyMember = false">Change</button>
                            </div>
                        </div>
                        <div class="form-group" v-else>
                            <label class="form-label mal-text">മൊബൈൽ നമ്പർ (Mobile) <span class="req">*</span></label>
                            <input type="tel" v-model="formData.mobile" class="form-input" placeholder="10 digit number"
                                pattern="[0-9]{10}" maxlength="10" inputmode="numeric" required
                                @blur="checkMobileAlreadyRegistered" @input="mobileCheckMessage = ''">
                            <p class="mobile-check-note mal-text" v-if="mobileCheckMessage">{{ mobileCheckMessage }}</p>
                        </div>
                        <div class="form-group">
                            <label class="form-label mal-text">ജനന തീയതി (DOB) <span class="req">*</span></label>
                            <input type="date" v-model="formData.dob" class="form-input" required>
                        </div>
                        <div class="form-group">
                            <label class="form-label mal-text">ജില്ല (District) <span class="req">*</span></label>
                            <select v-model="formData.district_id" class="form-input" required @change="onDistrictChange">
                                <option value="" disabled>Select District</option>
                                <option v-for="d in districts" :key="d.id" :value="d.id">{{ d.name }}</option>
                            </select>
                        </div>
                        <div class="form-group">
                            <label class="form-label mal-text">മണ്ഡലം (Zone) <span class="req">*</span></label>
                            <select v-model="formData.zone_id" class="form-input" required :disabled="!formData.district_id" @change="onZoneChange">
                                <option value="" disabled>Select Zone</option>
                                <option v-for="z in zones" :key="z.id" :value="z.id">{{ z.name }}</option>
                            </select>
                        </div>
                        <div class="form-group">
                            <label class="form-label mal-text">സ്ഥലം/യൂണിറ്റ് (Place/Unit) <span class="req">*</span></label>
                            <select v-model="formData.unit_id" class="form-input" required :disabled="!formData.zone_id" @change="onUnitChange">
                                <option value="" disabled>Select Unit</option>
                                <option v-for="u in units" :key="u.id" :value="u.id">{{ u.name }}</option>
                            </select>
                        </div>

                        <div class="form-group" v-if="formData.unit_id">
                            <label class="form-label mal-text">അടുത്തുള്ള പരീക്ഷാ കേന്ദ്രം (Nearby Exam Center)</label>
                            <select v-if="examCenters.length" v-model="formData.exam_center_id" class="form-input">
                                <option value="">Select if known (optional)</option>
                                <option v-for="c in examCenters" :key="c.id" :value="c.id">{{ c.name }}<template v-if="c.address"> — {{ c.address }}</template></option>
                            </select>
                            <div class="center-fallback mal-text" v-else-if="examCentersChecked">
                                Candidates can access their nearby exam center details on August 11 by providing their registered mobile number.
                            </div>
                        </div>

                        <p class="error-feedback" v-if="formError">{{ formError }}</p>
                        <button type="submit" class="btn-main mal-text" :disabled="loading">
                            <span v-if="!loading">രജിസ്റ്റർ ചെയ്യുക (Register)</span>
                            <div class="loading-spinner" v-else></div>
                        </button>
                        <button type="button" class="link-btn mal-text" @click="currentStep = 'start'">ബാക്ക് (Back)</button>
                    </form>
                </div>

                <!-- STEP: SUCCESS -->
                <div class="step-container" :class="{ active: currentStep === 'success' }">
                    <div class="result-box" v-if="lastRegistration">
                        <div class="success-icon">
                            <svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="#4a4fa0" stroke-width="2">
                                <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                                <polyline points="22 4 12 14.01 9 11.01"></polyline>
                            </svg>
                        </div>
                        <h3 class="mal-text">രജിസ്ട്രേഷൻ വിജയകരമായി പൂർത്തിയായി!</h3>
                        <p class="mal-text result-sub">Registration Successful</p>
                        <div class="reg-card">
                            <div class="reg-row"><span class="reg-label">Name</span><span class="reg-value">{{ lastRegistration.name }}</span></div>
                            <div class="reg-row"><span class="reg-label">Parent Name</span><span class="reg-value">{{ lastRegistration.parent_name }}</span></div>
                            <div class="reg-row"><span class="reg-label">Mobile</span><span class="reg-value">{{ lastRegistration.mobile }}</span></div>
                            <div class="reg-row"><span class="reg-label">DOB</span><span class="reg-value">{{ lastRegistration.dob }}</span></div>
                            <div class="reg-row"><span class="reg-label">District</span><span class="reg-value">{{ lastRegistration.district_name }}</span></div>
                            <div class="reg-row"><span class="reg-label">Zone</span><span class="reg-value">{{ lastRegistration.zone_name }}</span></div>
                            <div class="reg-row"><span class="reg-label">Unit</span><span class="reg-value">{{ lastRegistration.unit_name }}</span></div>
                            <div class="reg-row" v-if="lastRegistration.exam_center_name">
                                <span class="reg-label">Exam Center</span><span class="reg-value">{{ lastRegistration.exam_center_name }}</span>
                            </div>
                        </div>
                        <div class="center-fallback mal-text" v-if="!lastRegistration.exam_center_name" style="margin-top:16px;">
                            Candidates can access their nearby exam center details on August 11 by providing their registered mobile number.
                        </div>
                        <button type="button" class="btn-main mal-text" @click="registerAnother">Register Another Candidate</button>
                        <button type="button" class="link-btn mal-text" @click="currentStep = 'start'">ഹോം (Home)</button>
                    </div>
                </div>

                <!-- STEP: LOOKUP (login by mobile number) -->
                <div class="step-container" :class="{ active: currentStep === 'lookup' }">
                    <h2 class="section-title mal-text">എന്റെ രജിസ്ട്രേഷൻ</h2>
                    <form @submit.prevent="searchMyRegistrations">
                        <div class="form-group">
                            <label class="form-label mal-text">മൊബൈൽ നമ്പർ നൽകുക (Enter Mobile Number)</label>
                            <input type="tel" v-model="lookupMobile" class="form-input" placeholder="10 digit number"
                                pattern="[0-9]{10}" maxlength="10" inputmode="numeric" required>
                        </div>
                        <button type="submit" class="btn-main mal-text" :disabled="lookupLoading">
                            <span v-if="!lookupLoading">തിരയുക (Search)</span>
                            <div class="loading-spinner" v-else></div>
                        </button>
                        <button type="button" class="link-btn mal-text" @click="currentStep = 'start'">ബാക്ക് (Back)</button>
                    </form>

                    <div v-if="lookupSearched && !lookupLoading" style="margin-top:20px;">
                        <div v-if="myRegistrations.length">
                            <div class="main-mobile-banner mal-text">
                                പ്രധാന മൊബൈൽ നമ്പർ: <b>{{ lookupMobile }}</b>
                            </div>
                            <button type="button" class="btn-outline mal-text" style="margin-bottom:16px;" @click="addOtherMember">
                                + മറ്റ് അംഗങ്ങളെ ചേർക്കുക (Add Other Members)
                            </button>
                            <div v-for="(reg, index) in myRegistrations" :key="reg.id" class="reg-card">
                                <div class="reg-card-header">
                                    <span class="reg-number">{{ index + 1 }}</span>
                                    <span class="reg-name">{{ reg.name }}</span>
                                    <div class="reg-card-actions">
                                        <button type="button" @click="openEditRegistration(reg)" title="Edit">
                                            <ion-icon name="create-outline"></ion-icon>
                                        </button>
                                        <button type="button" class="danger" @click="deleteRegistration(reg)" title="Delete">
                                            <ion-icon name="trash-outline"></ion-icon>
                                        </button>
                                    </div>
                                </div>
                                <div class="reg-row"><span class="reg-label">Parent Name</span><span class="reg-value">{{ reg.parent_name }}</span></div>
                                <div class="reg-row"><span class="reg-label">Mobile</span><span class="reg-value">{{ reg.mobile }}</span></div>
                                <div class="reg-row"><span class="reg-label">DOB</span><span class="reg-value">{{ reg.dob }}</span></div>
                                <div class="reg-row"><span class="reg-label">District</span><span class="reg-value">{{ reg.district_name }}</span></div>
                                <div class="reg-row"><span class="reg-label">Zone</span><span class="reg-value">{{ reg.zone_name }}</span></div>
                                <div class="reg-row"><span class="reg-label">Unit</span><span class="reg-value">{{ reg.unit_name }}</span></div>
                                <div class="reg-row" v-if="reg.exam_center_name">
                                    <span class="reg-label">Exam Center</span><span class="reg-value">{{ reg.exam_center_name }}</span>
                                </div>
                                <div class="center-fallback mal-text" v-else style="margin-top:10px;">
                                    Candidates can access their nearby exam center details on August 11 by providing their registered mobile number.
                                </div>
                            </div>
                        </div>
                        <div class="alert-box alert-error" v-else>
                            ഈ നമ്പറിൽ രജിസ്ട്രേഷൻ കണ്ടെത്തിയില്ല. (No registration found for this number.)
                        </div>
                    </div>
                </div>

                <!-- STEP: EDIT REGISTRATION -->
                <div class="step-container" :class="{ active: currentStep === 'editRegistration' }">
                    <h2 class="section-title mal-text">രജിസ്ട്രേഷൻ എഡിറ്റ് ചെയ്യുക</h2>
                    <form @submit.prevent="submitEditRegistration">
                        <div class="form-group">
                            <label class="form-label mal-text">പേര് (Name) <span class="req">*</span></label>
                            <input type="text" v-model="editForm.name" class="form-input" placeholder="Full name" required>
                        </div>
                        <div class="form-group">
                            <label class="form-label mal-text">രക്ഷിതാവിന്റെ പേര് (Parent Name) <span class="req">*</span></label>
                            <input type="text" v-model="editForm.parent_name" class="form-input" placeholder="Parent's name" required>
                        </div>
                        <div class="form-group">
                            <label class="form-label mal-text">മൊബൈൽ നമ്പർ (Mobile)</label>
                            <div class="locked-mobile-display">
                                <span>{{ editForm.mobile }}</span>
                            </div>
                        </div>
                        <div class="form-group">
                            <label class="form-label mal-text">ജനന തീയതി (DOB) <span class="req">*</span></label>
                            <input type="date" v-model="editForm.dob" class="form-input" required>
                        </div>
                        <div class="form-group">
                            <label class="form-label mal-text">ജില്ല (District) <span class="req">*</span></label>
                            <select v-model="editForm.district_id" class="form-input" required @change="onEditDistrictChange">
                                <option value="" disabled>Select District</option>
                                <option v-for="d in districts" :key="d.id" :value="d.id">{{ d.name }}</option>
                            </select>
                        </div>
                        <div class="form-group">
                            <label class="form-label mal-text">മണ്ഡലം (Zone) <span class="req">*</span></label>
                            <select v-model="editForm.zone_id" class="form-input" required :disabled="!editForm.district_id" @change="onEditZoneChange">
                                <option value="" disabled>Select Zone</option>
                                <option v-for="z in editZones" :key="z.id" :value="z.id">{{ z.name }}</option>
                            </select>
                        </div>
                        <div class="form-group">
                            <label class="form-label mal-text">സ്ഥലം/യൂണിറ്റ് (Place/Unit) <span class="req">*</span></label>
                            <select v-model="editForm.unit_id" class="form-input" required :disabled="!editForm.zone_id" @change="onEditUnitChange">
                                <option value="" disabled>Select Unit</option>
                                <option v-for="u in editUnits" :key="u.id" :value="u.id">{{ u.name }}</option>
                            </select>
                        </div>

                        <div class="form-group" v-if="editForm.unit_id">
                            <label class="form-label mal-text">അടുത്തുള്ള പരീക്ഷാ കേന്ദ്രം (Nearby Exam Center)</label>
                            <select v-if="editExamCenters.length" v-model="editForm.exam_center_id" class="form-input">
                                <option value="">Select if known (optional)</option>
                                <option v-for="c in editExamCenters" :key="c.id" :value="c.id">{{ c.name }}<template v-if="c.address"> — {{ c.address }}</template></option>
                            </select>
                            <div class="center-fallback mal-text" v-else-if="editExamCentersChecked">
                                Candidates can access their nearby exam center details on August 11 by providing their registered mobile number.
                            </div>
                        </div>

                        <p class="error-feedback" v-if="editFormError">{{ editFormError }}</p>
                        <button type="submit" class="btn-main mal-text" :disabled="editSaving">
                            <span v-if="!editSaving">സേവ് ചെയ്യുക (Save)</span>
                            <div class="loading-spinner" v-else></div>
                        </button>
                        <button type="button" class="link-btn mal-text" @click="currentStep = 'lookup'">ബാക്ക് (Back)</button>
                    </form>
                </div>
            </div>
        </div>
        <footer class="page-footer mal-text">© 2026 | IT Wing Wisdom Islamic Organization.</footer>
    </div>
</template>

<script>
export default {
    name: 'WisdomExam',
    data() {
        return {
            API_BASE: 'https://guideportal.wisdomislam.org/api/public/wisdom-exam',
            // District/Zone/Unit dropdowns reuse the app's existing shared, already-public
            // org-hierarchy endpoint (LocationController) — same source every other
            // District→Zone→Unit dropdown in the app uses, not a bespoke endpoint of our own.
            LOCATION_API_BASE: 'https://guideportal.wisdomislam.org/api/location',
            currentStep: 'start',
            loading: false,
            alertMessage: '',
            alertType: 'error',
            formError: '',

            districts: [],
            zones: [],
            units: [],
            examCenters: [],
            examCentersChecked: false,

            formData: {
                name: '',
                parent_name: '',
                mobile: '',
                dob: '',
                district_id: '',
                zone_id: '',
                unit_id: '',
                exam_center_id: '',
            },
            // True when registering a sibling/family member under a mobile number already
            // found via "View My Registration" — locks the mobile field instead of re-entering it.
            isAddingFamilyMember: false,
            mobileCheckMessage: '',

            lastRegistration: null,

            lookupMobile: '',
            lookupLoading: false,
            lookupSearched: false,
            myRegistrations: [],

            // Edit Registration step — separate district/zone/unit/exam-center state from the
            // main registration form, so editing an existing entry doesn't collide with it.
            editForm: {
                id: '', mobile: '', name: '', parent_name: '', dob: '',
                district_id: '', zone_id: '', unit_id: '', exam_center_id: '',
            },
            editZones: [],
            editUnits: [],
            editExamCenters: [],
            editExamCentersChecked: false,
            editFormError: '',
            editSaving: false,
        };
    },
    mounted() {
        this.loadDistricts();
    },
    methods: {
        showAlert(message, type = 'error') {
            this.alertMessage = message;
            this.alertType = type;
            setTimeout(() => { this.alertMessage = ''; }, 4000);
        },
        goToRegister() {
            this.isAddingFamilyMember = false;
            this.formData = {
                name: '',
                parent_name: '',
                mobile: '',
                dob: '',
                district_id: '',
                zone_id: '',
                unit_id: '',
                exam_center_id: '',
            };
            this.zones = [];
            this.units = [];
            this.examCenters = [];
            this.examCentersChecked = false;
            this.currentStep = 'register';
        },
        goToLookup() {
            this.lookupSearched = false;
            this.myRegistrations = [];
            this.currentStep = 'lookup';
        },
        // "Register Another Candidate" from the success screen — stays in family-add mode (same
        // locked mobile) if that's how the just-submitted registration was made, else starts fresh.
        registerAnother() {
            if (this.isAddingFamilyMember) {
                this.lookupMobile = this.formData.mobile;
                this.addOtherMember();
            } else {
                this.goToRegister();
            }
        },
        // From the "View My Registration" results — register another candidate (e.g. a sibling)
        // under the same mobile number already looked up, without re-typing it.
        addOtherMember() {
            this.isAddingFamilyMember = true;
            this.formData = {
                name: '',
                parent_name: '',
                mobile: this.lookupMobile,
                dob: '',
                district_id: '',
                zone_id: '',
                unit_id: '',
                exam_center_id: '',
            };
            this.zones = [];
            this.units = [];
            this.examCenters = [];
            this.examCentersChecked = false;
            this.currentStep = 'register';
        },
        async loadDistricts() {
            try {
                // state_id=1 is Kerala (same convention as PublicQvpApiController's revenue-district
                // filtering) — excludes the org's out-of-state districts (Bangalore, Chennai,
                // Coimbatore, etc.) and "FOREIGN", which this exam only covers Kerala units for.
                const response = await fetch(this.LOCATION_API_BASE + '/districts?state_id=1');
                const data = await response.json();
                const list = (data.data && data.data.districts) || [];
                this.districts = list.filter((d) => String(d.name || '').trim().toUpperCase() !== 'FOREIGN');
            } catch (e) {
                this.districts = [];
            }
        },
        onDistrictChange() {
            this.formData.zone_id = '';
            this.formData.unit_id = '';
            this.zones = [];
            this.units = [];
            this.examCenters = [];
            this.examCentersChecked = false;
            this.formData.exam_center_id = '';
            this.loadZones();
        },
        async loadZones() {
            if (!this.formData.district_id) return;
            try {
                const response = await fetch(this.LOCATION_API_BASE + '/zones?district_id=' + this.formData.district_id);
                const data = await response.json();
                this.zones = (data.data && data.data.zones) || [];
            } catch (e) {
                this.zones = [];
            }
        },
        onZoneChange() {
            this.formData.unit_id = '';
            this.units = [];
            this.examCenters = [];
            this.examCentersChecked = false;
            this.formData.exam_center_id = '';
            this.loadUnits();
        },
        async loadUnits() {
            if (!this.formData.zone_id) return;
            try {
                const response = await fetch(this.LOCATION_API_BASE + '/units?zone_id=' + this.formData.zone_id);
                const data = await response.json();
                this.units = (data.data && data.data.units) || [];
            } catch (e) {
                this.units = [];
            }
        },
        onUnitChange() {
            this.formData.exam_center_id = '';
            this.loadExamCenters();
        },
        async loadExamCenters() {
            if (!this.formData.unit_id || !this.formData.zone_id) return;
            this.examCentersChecked = false;
            try {
                const response = await fetch(this.API_BASE + '/exam-centers?unit_id=' + this.formData.unit_id + '&zone_id=' + this.formData.zone_id);
                const data = await response.json();
                this.examCenters = data.data || [];
            } catch (e) {
                this.examCenters = [];
            } finally {
                this.examCentersChecked = true;
            }
        },
        // ---- Edit Registration step (from "View My Registration" results) ----
        async openEditRegistration(reg) {
            this.editForm = {
                id: reg.id,
                mobile: reg.mobile,
                name: reg.name,
                parent_name: reg.parent_name,
                dob: reg.dob_iso || '',
                district_id: reg.district_id || '',
                zone_id: '',
                unit_id: '',
                exam_center_id: reg.exam_center_id || '',
            };
            this.editZones = [];
            this.editUnits = [];
            this.editExamCenters = [];
            this.editExamCentersChecked = false;
            this.editFormError = '';

            if (this.editForm.district_id) {
                await this.loadEditZones();
                this.editForm.zone_id = reg.zone_id || '';
            }
            if (this.editForm.zone_id) {
                await this.loadEditUnits();
                this.editForm.unit_id = reg.unit_id || '';
            }
            if (this.editForm.unit_id) {
                await this.loadEditExamCenters();
                this.editForm.exam_center_id = reg.exam_center_id || '';
            }

            this.currentStep = 'editRegistration';
        },
        onEditDistrictChange() {
            this.editForm.zone_id = '';
            this.editForm.unit_id = '';
            this.editZones = [];
            this.editUnits = [];
            this.editExamCenters = [];
            this.editExamCentersChecked = false;
            this.editForm.exam_center_id = '';
            this.loadEditZones();
        },
        async loadEditZones() {
            if (!this.editForm.district_id) return;
            try {
                const response = await fetch(this.LOCATION_API_BASE + '/zones?district_id=' + this.editForm.district_id);
                const data = await response.json();
                this.editZones = (data.data && data.data.zones) || [];
            } catch (e) {
                this.editZones = [];
            }
        },
        onEditZoneChange() {
            this.editForm.unit_id = '';
            this.editUnits = [];
            this.editExamCenters = [];
            this.editExamCentersChecked = false;
            this.editForm.exam_center_id = '';
            this.loadEditUnits();
        },
        async loadEditUnits() {
            if (!this.editForm.zone_id) return;
            try {
                const response = await fetch(this.LOCATION_API_BASE + '/units?zone_id=' + this.editForm.zone_id);
                const data = await response.json();
                this.editUnits = (data.data && data.data.units) || [];
            } catch (e) {
                this.editUnits = [];
            }
        },
        onEditUnitChange() {
            this.editForm.exam_center_id = '';
            this.loadEditExamCenters();
        },
        async loadEditExamCenters() {
            if (!this.editForm.unit_id || !this.editForm.zone_id) return;
            this.editExamCentersChecked = false;
            try {
                const response = await fetch(this.API_BASE + '/exam-centers?unit_id=' + this.editForm.unit_id + '&zone_id=' + this.editForm.zone_id);
                const data = await response.json();
                this.editExamCenters = data.data || [];
            } catch (e) {
                this.editExamCenters = [];
            } finally {
                this.editExamCentersChecked = true;
            }
        },
        async submitEditRegistration() {
            this.editFormError = '';
            this.editSaving = true;
            try {
                const response = await fetch(this.API_BASE + '/update-registration', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                    body: JSON.stringify(this.editForm),
                });
                const data = await response.json();
                if (data.status !== 'success') {
                    this.editFormError = data.message || 'അപ്ഡേറ്റ് ചെയ്യാൻ കഴിഞ്ഞില്ല.';
                    return;
                }
                this.currentStep = 'lookup';
                this.searchMyRegistrations();
            } catch (e) {
                this.editFormError = 'എന്തോ തെറ്റ് സംഭവിച്ചു. ദയവായി വീണ്ടും ശ്രമിക്കുക.';
            } finally {
                this.editSaving = false;
            }
        },
        async deleteRegistration(reg) {
            if (!window.confirm('ഈ രജിസ്ട്രേഷൻ നീക്കം ചെയ്യണോ? (Delete this registration?)')) return;
            try {
                const response = await fetch(this.API_BASE + '/delete-registration', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                    body: JSON.stringify({ id: reg.id, mobile: reg.mobile }),
                });
                const data = await response.json();
                if (data.status === 'success') {
                    this.myRegistrations = this.myRegistrations.filter((r) => r.id !== reg.id);
                } else {
                    window.alert(data.message || 'Delete failed.');
                }
            } catch (e) {
                window.alert('Delete failed.');
            }
        },
        // Runs on blur of the Mobile field — purely informational (multiple registrations per
        // mobile are allowed, e.g. siblings), so it never blocks submission.
        async checkMobileAlreadyRegistered() {
            this.mobileCheckMessage = '';
            if (!/^[0-9]{10}$/.test(this.formData.mobile)) return;
            try {
                const response = await fetch(this.API_BASE + '/my-registrations', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                    body: JSON.stringify({ mobile: this.formData.mobile }),
                });
                const data = await response.json();
                if (data.status === 'success' && (data.data || []).length) {
                    this.mobileCheckMessage = 'ഈ നമ്പർ ഇതിനകം രജിസ്റ്റർ ചെയ്തിട്ടുണ്ട്. (This number is already registered.)';
                }
            } catch (e) {
                // ignore — non-blocking check
            }
        },
        async submitRegistration() {
            if (!/^[0-9]{10}$/.test(this.formData.mobile)) {
                this.formError = 'സാധുവായ 10 അക്ക മൊബൈൽ നമ്പർ നൽകുക.';
                return;
            }
            this.formError = '';
            this.loading = true;
            try {
                const response = await fetch(this.API_BASE + '/register', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                    body: JSON.stringify(this.formData),
                });
                const data = await response.json();
                if (data.status !== 'success') {
                    this.formError = data.message || 'രജിസ്ട്രേഷൻ പരാജയപ്പെട്ടു.';
                    this.loading = false;
                    return;
                }
                this.lastRegistration = data.data;
                this.currentStep = 'success';
            } catch (e) {
                this.formError = 'എന്തോ തെറ്റ് സംഭവിച്ചു. ദയവായി വീണ്ടും ശ്രമിക്കുക.';
            } finally {
                this.loading = false;
            }
        },
        async searchMyRegistrations() {
            if (!/^[0-9]{10}$/.test(this.lookupMobile)) {
                this.showAlert('സാധുവായ 10 അക്ക മൊബൈൽ നമ്പർ നൽകുക.');
                return;
            }
            this.lookupLoading = true;
            this.lookupSearched = false;
            try {
                const response = await fetch(this.API_BASE + '/my-registrations', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                    body: JSON.stringify({ mobile: this.lookupMobile }),
                });
                const data = await response.json();
                this.myRegistrations = data.data || [];
            } catch (e) {
                this.myRegistrations = [];
                this.showAlert('എന്തോ തെറ്റ് സംഭവിച്ചു. ദയവായി വീണ്ടും ശ്രമിക്കുക.');
            } finally {
                this.lookupLoading = false;
                this.lookupSearched = true;
            }
        },
    },
};
</script>

<style>
/* Full-bleed page — no app shell chrome, matches the pattern used by QHLS/QVP public pages. */
#appCapsule.wisdom-exam-shell {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
    margin-top: 0 !important;
    margin-bottom: 0 !important;
    background: #f6f4fb !important;
}
body:has(#appCapsule.wisdom-exam-shell) {
    background: #f6f4fb !important;
}
</style>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Outfit:wght@300;400;500;600;700;800&family=Baloo+2:wght@700;800&display=swap');

.wisdom-exam-page {
    --primary: #4a4fa0;
    --primary-dark: #34386f;
    --primary-light: #7478c9;
    --accent: #2e9e55;
    --accent-light: #e3f5e9;
    --bg-color: #f6f4fb;
    --input-bg: #f7f5fc;
    --text-main: #241a35;
    --text-light: #7c7290;

    font-family: 'Outfit', sans-serif;
    background: var(--bg-color);
    color: var(--text-main);
    line-height: 1.5;
    min-height: 100vh;
    padding: 0;
    margin: 0;
}

/* Hero banner — the logo PNGs are designed for a white background (their own text/wavy-line
   colors are dark navy and gray), so a light backdrop here is what actually makes them readable;
   the previous indigo gradient was too close in hue to the logo's own "മ" text color. */
.hero-banner {
    position: relative;
    overflow: hidden;
    background: #ffffff;
    padding: 36px 20px 76px;
    text-align: center;
}

.hero-shape {
    position: absolute;
    border-radius: 50%;
    background: rgba(74, 79, 160, 0.07);
}
.hero-shape-1 { width: 220px; height: 220px; top: -90px; right: -60px; }
.hero-shape-2 { width: 140px; height: 140px; bottom: -60px; left: -40px; background: rgba(46, 158, 85, 0.1); }

.hero-logos {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 14px;
    margin-bottom: 20px;
}

/* The source PNGs are a large square canvas with the actual logo artwork sitting as a small
   letterboxed strip in the middle — showing the whole square at a small size made the logo
   itself illegible. Each chip crops in on just that strip (via a fixed aspect-ratio window +
   an oversized, offset image) and scales it up so the artwork reads clearly on any screen. */
.hero-logo-chip {
    width: min(42vw, 165px);
    aspect-ratio: 797 / 453;
    overflow: hidden;
    position: relative;
    animation: logoPop 0.6s cubic-bezier(0.34, 1.56, 0.64, 1) backwards;
}
.hero-logo-chip:nth-child(2) { animation-delay: 0.12s; }

.hero-logo-chip img {
    position: absolute;
    width: 196%;
    height: 345%;
    left: -49%;
    top: -93%;
    max-width: none;
    filter: drop-shadow(0 3px 8px rgba(0, 0, 0, 0.3));
    transition: transform 0.25s ease;
}
.hero-logo-chip img:hover {
    transform: scale(1.05);
}

@keyframes logoPop {
    from { opacity: 0; transform: scale(0.75) translateY(8px); }
    to { opacity: 1; transform: scale(1) translateY(0); }
}

.hero-title {
    position: relative;
    font-family: 'Baloo 2', 'Outfit', sans-serif;
    font-size: 26px;
    font-weight: 800;
    letter-spacing: 0.2px;
    line-height: 1.25;
    margin-bottom: 8px;
    background: linear-gradient(120deg, var(--primary) 0%, var(--primary-light) 55%, var(--accent) 100%);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
    color: var(--primary);
}

.hero-banner .subtitle {
    position: relative;
    font-size: 14px;
    color: var(--text-light);
    font-weight: 400;
}

.status-badge {
    position: relative;
    display: inline-block;
    background: var(--accent);
    color: #fff;
    padding: 5px 16px;
    border-radius: 100px;
    font-size: 12.5px;
    font-weight: 700;
    margin-top: 14px;
    box-shadow: 0 4px 10px rgba(46, 158, 85, 0.4);
}

/* Floating card */
.page-wrapper {
    width: 100%;
    max-width: 500px;
    margin: -46px auto 0;
    padding: 0 18px 60px;
    position: relative;
}

.floating-card {
    background: #fff;
    border-radius: 22px;
    padding: 26px 22px 30px;
    box-shadow: 0 16px 40px rgba(74, 79, 160, 0.16);
}

.section-title {
    font-size: 16px;
    font-weight: 700;
    color: var(--primary);
    margin-bottom: 18px;
    text-align: center;
}

.alert-box {
    padding: 14px 16px;
    border-radius: 12px;
    font-size: 13.5px;
    margin-bottom: 16px;
    text-align: center;
}
.alert-error { background: #fdf0f0; color: #b91c1c; }
.alert-success { background: #f1ebfc; color: var(--primary); }

.form-group {
    margin-bottom: 18px;
}

.form-label {
    display: block;
    margin-bottom: 7px;
    font-size: 13px;
    font-weight: 600;
    color: var(--primary);
    margin-left: 2px;
}
.req { color: #dc2626; }

.form-input {
    width: 100%;
    padding: 14px 16px;
    background: var(--input-bg);
    border: 1.5px solid #ece7f7;
    border-radius: 12px;
    font-size: 15.5px;
    font-family: inherit;
    color: var(--text-main);
    transition: all 0.2s ease;
}
.form-input:focus {
    outline: none;
    background: #fff;
    border-color: var(--primary-light);
    box-shadow: 0 0 0 4px rgba(116, 120, 201, 0.15);
}
.form-input:disabled {
    opacity: 0.55;
}

.btn-main {
    width: 100%;
    padding: 16px;
    background: linear-gradient(135deg, var(--primary), var(--primary-light));
    color: #fff;
    border: none;
    border-radius: 14px;
    font-size: 15px;
    font-weight: 700;
    letter-spacing: 0.3px;
    cursor: pointer;
    transition: transform 0.15s, box-shadow 0.15s;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 6px;
    box-shadow: 0 8px 18px rgba(74, 79, 160, 0.28);
}
.btn-main:active { transform: scale(0.98); }
.btn-main:disabled { background: #b7aecb; box-shadow: none; cursor: not-allowed; }

.btn-outline {
    width: 100%;
    padding: 16px;
    background: #fff;
    color: var(--primary);
    border: 2px solid var(--primary);
    border-radius: 14px;
    font-size: 15px;
    font-weight: 700;
    cursor: pointer;
    margin-top: 14px;
    transition: transform 0.15s;
}
.btn-outline:active { transform: scale(0.98); }

.link-btn {
    display: block;
    width: 100%;
    text-align: center;
    background: none;
    border: none;
    color: var(--text-light);
    font-size: 13.5px;
    padding: 14px 0 0;
    cursor: pointer;
}

.loading-spinner {
    width: 20px;
    height: 20px;
    border: 3px solid rgba(255, 255, 255, 0.4);
    border-top-color: #fff;
    border-radius: 50%;
    animation: spin 0.7s linear infinite;
}
@keyframes spin { to { transform: rotate(360deg); } }

.step-container {
    display: none;
    animation: fadeIn 0.4s forwards;
}
.step-container.active { display: block; }
@keyframes fadeIn { from { opacity: 0; transform: translateY(6px); } to { opacity: 1; transform: translateY(0); } }

.center-fallback {
    background: var(--accent-light);
    color: #1f6b3a;
    border-radius: 12px;
    padding: 14px 16px;
    font-size: 13px;
    line-height: 1.5;
    border: 1px solid rgba(46, 158, 85, 0.35);
}

.mobile-check-note {
    margin: 8px 4px 0;
    font-size: 12.5px;
    color: #b45309;
}

.page-footer {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    text-align: center;
    font-size: 12px;
    color: var(--text-light);
    padding: 10px 20px;
    background: rgba(255, 255, 255, 0.9);
    backdrop-filter: blur(4px);
    z-index: 20;
}

.main-mobile-banner {
    background: var(--input-bg);
    border: 1px solid #ece7f7;
    border-radius: 12px;
    padding: 10px 14px;
    font-size: 13.5px;
    color: var(--text-main);
    margin-bottom: 10px;
    text-align: center;
}

.locked-mobile-display {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: var(--input-bg);
    border: 1.5px solid #ece7f7;
    border-radius: 12px;
    padding: 14px 16px;
    font-size: 15.5px;
    font-weight: 600;
    color: var(--text-main);
}
.locked-mobile-display .link-btn {
    width: auto;
    padding: 0;
    font-size: 13px;
    color: var(--primary);
    font-weight: 600;
}

.result-box { text-align: center; }
.success-icon {
    width: 58px;
    height: 58px;
    border-radius: 50%;
    background: #eceef8;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto 16px;
}
.result-box h3 {
    color: var(--primary);
    font-size: 18.5px;
    margin-bottom: 4px;
}
.result-sub {
    color: var(--text-light);
    font-size: 13px;
    margin-bottom: 20px;
}

.reg-card {
    background: var(--input-bg);
    border: 1px solid #ece7f7;
    border-radius: 16px;
    padding: 18px;
    text-align: left;
    margin-bottom: 14px;
}
.reg-card-header {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 10px;
    padding-bottom: 10px;
    border-bottom: 1px solid rgba(74, 79, 160, 0.16);
}
.reg-number {
    width: 26px;
    height: 26px;
    border-radius: 50%;
    background: linear-gradient(135deg, var(--primary), var(--primary-light));
    color: #fff;
    font-size: 12.5px;
    font-weight: 700;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}
.reg-name {
    flex: 1;
    font-size: 16px;
    font-weight: 700;
    color: var(--text-main);
}
.reg-card-actions {
    display: flex;
    gap: 4px;
    flex-shrink: 0;
}
.reg-card-actions button {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    border: none;
    background: #fff;
    color: var(--primary);
    font-size: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
}
.reg-card-actions button.danger {
    color: #dc2626;
}
.reg-row {
    display: flex;
    justify-content: space-between;
    gap: 12px;
    padding: 6px 0;
    font-size: 13.5px;
}
.reg-label { color: var(--text-light); }
.reg-value { color: var(--text-main); font-weight: 600; text-align: right; }
</style>
